import { Controller } from '@hotwired/stimulus';
import { input } from '../../../../libs/cifra/dialogs';
import { EVENTO_ANTES_CARGAR } from '../modal_remoto_controller';

/* global $, I18n, Cifra, set_overlay_ajax */
const SELECTOR_LINEA = '.linea-factura';
const SELECTOR_INPUTS_LINEA = 'input, select, button.guardarLinea, button.cancelarLinea, .input-linea';

export default class extends Controller {
  connect() {
    this.#conectarCodigoViejo();
  }

  #conectarCodigoViejo() {
    this.#conectarModalServicios();
    this.#conectar_factura_form();
    this.#conectarDescuentoPorcentaje();
  }

  #conectarDescuentoPorcentaje() {
    this.element.querySelectorAll('.btn-descuento-porcentaje').forEach((element) => {
      element.addEventListener('click', () => {
        input({
          title: I18n.t('porcentaje'),
        }).then((valor) => {
          this.#aplicarDescuentoPorcentaje(element, valor)
        });
      });
    });
  }

  // eslint-disable-next-line class-methods-use-this
  #aplicarDescuentoPorcentaje(boton, valor) {
    if (!valor) {
      return;
    }
    const porcentaje = parseFloat(valor.replaceAll(',', '.'));
    const fila = boton.closest(SELECTOR_LINEA);
    const $importe = $(fila.querySelector('input.i_importe'));
    const $descuento = $(fila.querySelector('input.i_descuento'));
    const precioUnidad = parseFloat($importe.autoNumeric('get'));
    if (!precioUnidad) {
      return;
    }
    const descuento = precioUnidad * porcentaje / 100;
    $descuento.autoNumeric('set', descuento);
    // No sé por qué autoNumeric al hacer el set no actualiza el campo oculto
    // Llamamos a change porque autoNumeric no actualiza el campo hidden
    $descuento.change();
  }

  
  #conectarModalServicios() {
    const botonModalRemoto = this.element.querySelector('#seleccionar-servicios');
    botonModalRemoto.addEventListener(EVENTO_ANTES_CARGAR, (event) => {
      event.detail.url.searchParams.append('usuario_id', this.element.querySelector('#usuario_id').value);
    });
  }

  // eslint-disable-next-line class-methods-use-this
  #conectar_factura_form() {
    $('#editarFecha').click(() => {
      $('#show-fecha').hide();
      $('#form-fecha').removeClass('hide');
      return false;
    });

    $('#cancelarFecha').click(function cancelarFecha() {
      $(this).closest('form').addClass('hide').prev()
        .show();
      return false;
    });

    $('#editarObservaciones').click(function editarObservaciones() {
      $(this).parent().hide().next()
        .removeClass('hide');
      return false;
    });

    $('#cancelarObservaciones').click(function cancelarObservaciones() {
      $(this).closest('form').addClass('hide').prev()
        .show();
      $('#observaciones').val($('#currentObservaciones').text());
      return false;
    });

    $('a.editarLinea').click(function editarLinea() {
      const $tr = $(this).closest('tr');
      const tieneServicio = $tr.data('servicio-id') !== '';
      $tr.addClass('editing');
      $tr.find(SELECTOR_INPUTS_LINEA).removeClass('hide');
      $tr.find('span, a.editarLinea, a.borrarLinea').hide();
      if (tieneServicio) {
        $tr.find('.concepto').find('select, input').prop('disabled', true);
      }
      return false;
    });

    $('button.cancelarLinea').click(function cancelarLinea() {
      const $tr = $(this).closest('tr');
      $tr.removeClass('editing');
      $tr.find(SELECTOR_INPUTS_LINEA).addClass('hide');
      $tr.find('span, a.editarLinea, a.borrarLinea').show();
      $tr.find('select.i_alumno').val(parseFloat($tr.find('span.s_alumno').data('usuario-id')));
      $tr.find('input.i_texto').val($tr.find('span.s_texto').text());
      $tr.find('input.i_unidades').val($tr.find('span.unidades').text());
      $tr.find('input.i_importe').val(parseFloat($tr.find('span.importe').text()));
      $tr.find('input.i_descuento').val(parseFloat($tr.find('span.descuento').text()));
      $tr.find('select.i_tipo_iva').val(parseFloat($tr.find('span.tipo_iva').data('iva-id')));
      return false;
    });

    $('button.guardarLinea').click(function guardarLinea() {
      set_overlay_ajax($('#factura'));

      const $this = $(this);
      const $form = $('#form_edit_linea');

      $('<input />', {
        type: 'hidden',
        name: 'linea',
        value: $this.closest('tr').data('id'),
      }).appendTo($form);

      $.each($this.closest('tr').find('input, select'), function gestionarTrLinea() {
        const $input = $(this);

        $('<input />', {
          type: 'hidden',
          name: $input.attr('name'),
          value: $input.val(),
        }).appendTo($form);
      });

      $form.appendTo('body').submit();

      return false;
    });

    $('#nuevaLinea').click(function nuevaLinea() {
      set_overlay_ajax($('#factura'));

      const $this = $(this);
      const $form = $('#form_new_linea');

      $('<input />', {
        type: 'hidden',
        name: 'usuario_id',
        value: $('#usuario_id').val()
      }).appendTo($form);

      $.each($this.closest('tr').find('input, select'), function gestionarTrLinea() {
        const $input = $(this);

        $('<input />', {
          type: 'hidden',
          name: $input.attr('name'),
          value: $input.val(),
        }).appendTo($form);
      });

      $form.appendTo('body').submit();

      return false;
    });

    $('#cancelarFormaPago').click(() => {
      const currentFormaPago = $('#currentFormaPago');
      $('.form-forma-pago').addClass('hide');
      currentFormaPago.show();
      $('#editarFormaPago').show();
      $('#forma_pago').val(currentFormaPago.data('id')).trigger('change');
      return false;
    });

    // Forma de pago
    $('#editarFormaPago').click(function editarFormaPago() {
      $(this).hide();
      $('#currentFormaPago').hide();
      $('.form-forma-pago').removeClass('hide');
      return false;
    });

    $('#metodo_pago_id').on('change', function cambiaMetodoPago() {
      if ($(this).find('option:selected').data('forma-pago-id') === Cifra.Conf.FORMA_PAGO_TRANSFERENCIA) {
        $('#cuenta').removeClass('hide');
      } else {
        $('#cuenta').addClass('hide');
      }
    });

    $('#enviarFactura').click(() => {
      set_overlay_ajax($('#modal-enviar-factura').find('.modal-content'));
    });

    $('#guardarObservaciones, #guardarFormaPago').on('click', () => {
      set_overlay_ajax($('#factura'));
    });

    // Gestión de nueva línea de factura
    $('.new, .form-add-concepto').hide();
    $('#btn-add-concepto').click(function addConcepto() {
      $(this).hide();
      $('.form-add-concepto').fadeIn();
    });
    $('.form-add-concepto .btn-close').click(() => {
      $('.form-add-concepto').hide();
      $('#btn-add-concepto').fadeIn();
    });
    $('#concepto_manual').click((e) => {
      e.preventDefault();
      $('.form-add-concepto').hide();
      $('.alumno-concepto').text($('#usuario_id option:selected').text());
      $('.new').fadeIn();
    });
    $('#cancelarNuevaLinea').click((e) => {
      e.preventDefault();
      $('.form-add-concepto').fadeIn();
      $('.new').hide();
    });
    if ($('#factura .linea-factura').length === 0) {
      $('.form-add-concepto').show();
      $('#btn-add-concepto').hide();
    }
    // Fin gestión de nueval línea de factura

    $('#gestion_economica_factura_tag_list').on('change.select2', function changeTag(e) {
      // Select2 lanza el evento change dos veces, una al añadir el tag y otra al reordenar los tags
      // https://metabox.io/support/topic/select-advance-triggers-onchange-event-twice/
      const $select = $(this);
      if (!$select.data('select2-change-event')) {
        setTimeout(() => {
          $select.closest('form').submit();
          $select.removeData('select2-change-event');
        }, 50);
      }
      $select.data('select2-change-event', e);
    });
  }
}
